var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gridCard",style:({gridTemplateColumns: ("repeat(" + _vm.column + ", minmax(" + _vm.min + "px, 1fr))"), gridGap: (_vm.gap + "px")})},[_vm._t("item")],2)}
var staticRenderFns = []

export { render, staticRenderFns }